import LogoMark from "@/components/LogoMark";

export default function Footer() {
  return (
    <footer data-testid="footer" className="px-6 pb-16 pt-8 text-center">
      <div
        className="h-px w-40 mx-auto mb-10"
        style={{ background: "linear-gradient(90deg, transparent, var(--gold), transparent)" }}
      />
      <LogoMark className="w-10 h-10 mx-auto opacity-80" />
      <p className="mt-4 text-xs tracking-[0.5em] pl-[0.5em]" style={{ color: "var(--muted)" }}>
        SPORTS SWEAT
      </p>
      <p className="mt-2 text-[11px] tracking-[0.25em]" style={{ color: "var(--muted)" }}>
        31.10.2026 — GOIANÉSIA, GO
      </p>
      <a
        data-testid="admin-link"
        href="/admin"
        className="inline-block mt-8 text-[11px] tracking-[0.25em] uppercase opacity-50 hover:opacity-100 transition-opacity"
        style={{ color: "var(--muted)" }}
      >
        Área do organizador
      </a>
    </footer>
  );
}
